import React from 'react'
import { object, array, arrayOf } from 'prop-types'
import withSend from 'microcosm/addons/with-send'
import cx from 'classnames'
import colors, { getColor } from '../../../config/colors'
import Select from 'lib/components/select'
import SelectedLink from 'lib/components/selected-link'
import PatchLink from 'lib/components/patch-link'
import Icon from 'lib/components/icon'
import RA from 'ra-config'

class SidebarAggregate extends React.PureComponent {
  static defaultProps = {
    series: []
  }

  static propTypes = {
    query: object,
    strategies: arrayOf(object),
    series: array
  }

  renderCategory(category) {
    const { strategies, query } = this.props
    const { name: categoryName } = category

    const itemsForCategory = strategies.filter(
      ({ Category }) => Category === categoryName
    )

    const color = getColor(categoryName)
    const isActive = categoryName === query.category
    const categoryClassName = cx({ active: isActive })

    return (
      <li
        key={`sidebar-category-${categoryName}`}
        className={categoryClassName}
        style={{ color }}
      >
        <div className="sidebar-list-category">
          <SelectedLink
            category={categoryName}
            isActive={isActive}
            track={categoryName}
            trackAs="sidebar-category"
          >
            <svg className="sidebar-list-key">
              <circle fill={color} r="6" cx="6" cy="6" />
            </svg>

            <h3 className="type-title">{categoryName}</h3>
          </SelectedLink>

          <SelectedLink
            category={undefined}
            selected={undefined}
            className="sidebar-list-close"
          >
            <Icon type="close" height="20px" width="20px" />
            <span className="screenreader-only">Clear Filter</span>
          </SelectedLink>
        </div>

        <ul>{itemsForCategory.map(this.renderCategoryItem, this)}</ul>
      </li>
    )
  }

  renderCategoryItem({ ID, Key, Category, Name }) {
    const track = `Strategies: ${Name}`
    return (
      <li key={Key} data-id={ID}>
        <SelectedLink
          category={Category}
          selected={Key}
          track={track}
          trackAs="sidebar-item"
        >
          {Name}
        </SelectedLink>
      </li>
    )
  }

  render() {
    const { query } = this.props
    const { topNavigation } = RA.app.page
    const { categoryList } = RA.app.strategies

    const listClassName = cx('sidebar-list', {
      filtered: query.category != null
    })

    return (
      <aside className="sidebar -dock">
        <div className="sidebar__main">
          <Select
            label="Select Equity Category"
            labelFor="location-filter"
            labelVisible={false}
            onChange={this.onSelectChange}
            options={topNavigation}
            selected="/strategies"
            selectedText="Strategies"
          />

          <ul id="sidebar-strategies" className={listClassName}>
            {categoryList.map(this.renderCategory, this)}
          </ul>
        </div>

        <div className="sidebar__dock">
          <PatchLink
            query={{
              selected: 'benchmark-large-cap-benchmark',
              category: undefined,
              expanded: undefined,
              expandedSelection: undefined
            }}
            id="large-cap-link"
          >
            <svg className="sidebar-list-key">
              <rect
                fill={colors.black}
                x="4"
                y="-4"
                width="8"
                height="8"
                transform="matrix(0.7071068,0.7071068,-0.7071068,0.7071068,0,0)"
              />
            </svg>

            <h3 className="type-title" style={{ color: colors.black }}>
              Large Cap Benchmark
            </h3>
          </PatchLink>
        </div>
      </aside>
    )
  }

  onSelectChange = event => {
    event.target.blur()
    this.props.send('visit', event.target.value)
  }
}

export default withSend(SidebarAggregate)



// WEBPACK FOOTER //
// ./src/components/strategies/aggregate/sidebar.js